import { render, staticRenderFns } from "./middle1.vue?vue&type=template&id=24eb979c&scoped=true&"
import script from "./middle1.vue?vue&type=script&lang=js&"
export * from "./middle1.vue?vue&type=script&lang=js&"
import style0 from "./middle1.vue?vue&type=style&index=0&id=24eb979c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb979c",
  null
  
)

export default component.exports